export default __webpack_public_path__ + "b1862fc46e0f93329c488e1aa0bf4972.jpg";